import { Component } from '@angular/core';

@Component({
	selector: 'cc-tracking-widget',
	templateUrl: './tracking-widget.component.html',
	styleUrls: ['./tracking-widget.component.css']
})
export class TrackingWidgetComponent {

	public ShipmentIdentifer: string = "";
	
}